module.exports = __webpack_public_path__ + "static/media/giftsSent_50_75.c9de4285.png";